module.exports = __webpack_public_path__ + "static/media/pba_logo.4704faac.svg";